import React from "react";
import { motion } from 'framer-motion';

//components
import About from "./about/About";
import Hero from "./hero/Hero";
import Projects from "./projects/Projects";

export default function Home() {
  return (
    <motion.div
      initial={
          {
              opacity: 0,
          }
      }
      animate={
          {
              opacity: 1,
          }
      }
      exit={
          {
              opacity: 0,
          }
      }
    >
      <Hero />
      <About />
      <Projects />
    </motion.div>
  );
}
